import { FluxStandardAction } from "__utils/type";
import * as Actions from "../../constants/actions";

export const fetchCreateLead = (data: any, tag: string): FluxStandardAction => {
    return {
        type: Actions.FETCH_CREATE_LEAD,
        payload: {
            data: data,
            tag: tag
        }
    }
};

export const setLeadCreated = (leadCreated: boolean): FluxStandardAction => {
    return {
        type: Actions.SET_LEAD_CREATED,
        payload: {
            data: leadCreated
        }
    }
};

export const setFailedToCreateLead = (failedToCreateLead: boolean): FluxStandardAction => {
    return {
        type: Actions.SET_FAILED_TO_CREATE_LEAD,
        payload: {
            data: failedToCreateLead
        }
    }
};